import type { IHikCentralImportRepository, MemberSearchResult } from '@yawi/domain';
import type {
  HikCentralImportApplyRequest,
  HikCentralImportPreviewResponse,
  HikCentralImportResult,
} from '@yawi/types';
import { getApiClient } from '../../http/apiClient';

export class ApiHikCentralImportRepository implements IHikCentralImportRepository {
  private readonly basePath = 'v1/tenant/integrations/import/hikcentral-persons';

  async preview(tenantId: string, file: File): Promise<HikCentralImportPreviewResponse> {
    const client = getApiClient();
    const formData = new FormData();
    formData.append('file', file);
    const response = await client.post<HikCentralImportPreviewResponse>(
      `${this.basePath}/preview`,
      formData,
      { headers: { 'x-tenant-id': tenantId } },
    );
    return response as unknown as HikCentralImportPreviewResponse;
  }

  async apply(tenantId: string, request: HikCentralImportApplyRequest): Promise<HikCentralImportResult> {
    const client = getApiClient();
    const response = await client.post<HikCentralImportResult>(
      `${this.basePath}/apply`,
      request,
      { headers: { 'x-tenant-id': tenantId } },
    );
    return response as unknown as HikCentralImportResult;
  }

  async searchMembers(tenantId: string, query: string): Promise<MemberSearchResult[]> {
    const client = getApiClient();
    const qs = new URLSearchParams({ search: query, page: '1', limit: '15' }).toString();
    const response = await client.get<{ data?: Array<{ id: string; name: string }>; items?: Array<{ id: string; name: string }> }>(
      `v1/users?${qs}`,
      { headers: { 'x-tenant-id': tenantId } },
    );
    const raw = response as unknown as { data?: Array<{ id: string; name: string }> } | Array<{ id: string; name: string }>;
    const items = Array.isArray(raw) ? raw : (raw as { data?: Array<{ id: string; name: string }> }).data ?? [];
    return items.map((u) => ({ id: u.id, displayName: u.name }));
  }
}
